export const getVoiceCallStatusColor = (status: string): string => {
  switch (status) {
    case "Completed":
      return "bg-green-100 text-green-700";
    case "Pending":
      return "bg-gray-100 text-gray-600";
    case "No Answer":
    case "Busy":
      return "bg-yellow-100 text-yellow-700";
    default:
      return "bg-gray-100 text-gray-600";
  }
};
